'use strict';
'use es6';

// SEND

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IFRAME_RESIZE = exports.IFRAME_RESIZE = 'iframe-resize';

var OPEN_CHANGE = exports.OPEN_CHANGE = 'open-change';

var CLOSED_WELCOME_MESSAGE = exports.CLOSED_WELCOME_MESSAGE = 'closed-welcome-message';

var REQUEST_WIDGET = exports.REQUEST_WIDGET = 'request-widget';

// RECIEVE

var WIDGET_DATA = exports.WIDGET_DATA = 'widget-data';

var REQUEST_OPEN = exports.REQUEST_OPEN = 'request-open';


//////////////////
// WEBPACK FOOTER
// ./js/constants/PostMessageTypes.js
// module id = 553
// module chunks = 0